<template>
    <v-container>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm6 md3 class="px-2">
                <v-text-field
                    label="Startdatum"
                    type="date"
                    :value="startDate"
                    @change="onStartChange"
                    :min="'2019-10-30'"
                    :max="'2025-09-30'"
                    dense
                    hide-details
                />
            </v-flex>
            <v-flex xs12 sm6 md3 class="px-2">
                <v-text-field
                    label="Slutdatum"
                    type="date"
                    :value="endDate"
                    @change="onEndChange"
                    :min="'2019-10-30'"
                    :max="'2025-09-30'"
                    dense
                    hide-details
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "DateSelector",
    computed: {
        ...mapState({
            startDate: state => state.dateRange.start,
            endDate: state => state.dateRange.end
        })
    },
    methods: {
        ...mapActions(["updateDateRange"]),
        onStartChange(value) {
            this.updateDateRange({ start: value || null, end: this.endDate });
        },
        onEndChange(value) {
            this.updateDateRange({ start: this.startDate, end: value || null });
        }
    }
};
</script>
